/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Pace_RangeInputs */

const en_exp_avg_pace_range = /** @type {(inputs: Exp_Avg_Pace_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highly individual. Recreational runners: 6:00–7:30/km. Competitive amateurs: 4:30–6:00/km. Elite: sub-3:30/km. Compare to your own history and threshold pace.`)
};

const de_exp_avg_pace_range = /** @type {(inputs: Exp_Avg_Pace_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr individuell. Freizeitläufer: 6:00–7:30/km. Ambitionierte: 4:30–6:00/km. Elite: unter 3:30/km. Am besten mit der eigenen Historie und dem Schwellentempo vergleichen.`)
};

/**
* | output |
* | --- |
* | "Highly individual. Recreational runners: 6:00–7:30/km. Competitive amateurs: 4:30–6:00/km. Elite: sub-3:30/km. Compare to your own history and threshold pace." |
*
* @param {Exp_Avg_Pace_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_pace_range = /** @type {((inputs?: Exp_Avg_Pace_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Pace_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_pace_range(inputs)
	return de_exp_avg_pace_range(inputs)
});